
import firebase from 'firebase';
import 'firebase/auth'


const firebaseConfig = {
    apiKey: "AIzaSyBr6C9c9tx1L7OAS3w2HM2iXKUCQNVRqu0",
    authDomain: "personal-web-site-f870f.firebaseapp.com",
    projectId: "personal-web-site-f870f",
    storageBucket: "personal-web-site-f870f.appspot.com",
    messagingSenderId: "965668072949",
    appId: "1:965668072949:web:fce6bcc21749810d94c4bc",
    measurementId: "G-8LHNEEXDBX"
};
firebase.initializeApp(firebaseConfig);
export default firebase;








// WEBPACK FOOTER //
// ./src/.util/FirebaseConnect.js